import PacksComponent from './PacksComponent';
import FlexTestimonial from './flex/FlexTestimonial';
import FlexTestimonies from './flex/FlexTestimonies';
import FunnelComponent from './FunnelComponent';
import ConfirmationComponent from './ConfirmationComponent';
import SpriteIcon from './elements/SpriteIcon';

export default {
    PacksComponent,
    FlexTestimonies,
    FlexTestimonial,
    FunnelComponent,
    ConfirmationComponent,
    SpriteIcon,
};
